import { WebAppState } from '../realtime';
import type { DisplayPanelMode } from './videoCallMachine';

export type VideoPreparationImage =
  'appleEedShare' | 'googleElsShare' | 'webAppSms' | 'webAppCamera' | 'webAppLocation';

export type VideoPreparationGuideDefinition = {
  image: VideoPreparationImage;
  titleKey: string;
  actionLabelKey: string;
  footerKey: string | null;
  testID: string;
};

const GUIDES = {
  appleEedShare: {
    image: 'appleEedShare',
    titleKey: 'Incident_Video_AppleEedPreparation_Request',
    actionLabelKey: 'Incident_Video_AppleEedPreparation_Share',
    footerKey: null,
    testID: 'incident-video-apple-eed-preparation-panel',
  },
  googleElsShare: {
    image: 'googleElsShare',
    titleKey: 'Incident_Video_GoogleElsPreparation_Title',
    actionLabelKey: 'Incident_Video_GoogleElsPreparation_Share',
    footerKey: 'Incident_Video_GoogleElsPreparation_Speaker',
    testID: 'incident-video-google-els-preparation-panel',
  },
  webAppSms: {
    image: 'webAppSms',
    titleKey: 'Incident_Video_WebAppPreparation_Sms',
    actionLabelKey: 'Incident_Video_WebAppPreparation_Sms',
    footerKey: null,
    testID: 'incident-video-webapp-preparation-panel',
  },
  webAppCamera: {
    image: 'webAppCamera',
    titleKey: 'Incident_Video_WebAppPreparation_Camera',
    actionLabelKey: 'Incident_Video_WebAppPreparation_Camera',
    footerKey: null,
    testID: 'incident-video-webapp-preparation-panel',
  },
  webAppLocation: {
    image: 'webAppLocation',
    titleKey: 'Incident_Video_WebAppPreparation_Location',
    actionLabelKey: 'Incident_Video_WebAppPreparation_Location',
    footerKey: null,
    testID: 'incident-video-webapp-preparation-panel',
  },
} as const satisfies Record<VideoPreparationImage, VideoPreparationGuideDefinition>;

export function getVideoPreparationGuide(
  mode: DisplayPanelMode,
  webAppState: WebAppState,
): VideoPreparationGuideDefinition | null {
  if (mode === 'AppleEedInstructions') return GUIDES.appleEedShare;
  if (mode === 'GoogleElsInstructions') return GUIDES.googleElsShare;
  if (mode !== 'WebAppState') return null;

  switch (webAppState) {
    case WebAppState.None:
    case WebAppState.WebAppSmsSent:
      return GUIDES.webAppSms;
    case WebAppState.CameraPermissionRequested:
      return GUIDES.webAppCamera;
    case WebAppState.LocationPermissionRequested:
      return GUIDES.webAppLocation;
    default:
      return null;
  }
}
